import React from "react";
import { connect } from "react-redux";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";

import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { BACKUP_PLAN_SCHEDULE_TYPES } from "App/componentsConfig";
import { objectToArray } from "utils";
import NextSchedule from "./../../../../../../Dashboard/BackupSettings/Edit/body/Schedule/NextSchedule";
import BackupPlanAdvanced from "./BackupPlanAdvanced";

function BackupPlanSchedule(props) {
  const currentType =
    props.enums.ScheduleType.props[props.planSettings.scheduleInfo.type];
  const [pastSchedule, setPastSchedule] = React.useState(0);

  return (
    <div className="plan_cont_blk summary_wrap summary_schedule is_relative">
      <div className="summary_wrap_body">
        <div className="schedule_backup_wrap" style={{ display: "block" }}>
          <div className="transparent_layer"></div>
          <div className="schedule_backup_tabs">
            <ul className="schedule_backup_ul">
              {objectToArray(BACKUP_PLAN_SCHEDULE_TYPES).map((val, i) => {
                const enumKey = props.enums.ScheduleType[val.key];

                return (
                  <li key={i}>
                    <label className="radio_container">
                      <input
                        type="radio"
                        className="input_radio"
                        checked={
                          enumKey === props.planSettings.scheduleInfo.type
                        }
                        name="initial_backup_radio"
                        value={i}
                        onChange={() => {
                          setPastSchedule(props.planSettings.scheduleInfo.type);
                          props.setPlanSettings({
                            ...props.planSettings,
                            scheduleInfo: {
                              ...props.planSettings.scheduleInfo,
                              type: enumKey
                            }
                          });
                        }}
                        tabIndex={0}
                      />
                      <span className="radio_checkmark" />
                      <span className="fs_16">{val.name}</span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            className={[
              "schedule_backup_body",
              "transparent_layer_wrap",
              "transparent_layer_schedule",
              currentType.key === "NO_SCHEDULE" ? "layer_active" : null
            ].join(" ")}
          >
            <div className="transparent_layer"></div>
            <div
              className={[
                "sche_backup_item",
                currentType.key === "NO_SCHEDULE"
                  ? "backup_" +
                    props.enums.ScheduleType.props[pastSchedule].name
                  : "backup_" + currentType.name,
                "active"
              ].join(" ")}
            >
              {React.createElement(
                BACKUP_PLAN_SCHEDULE_TYPES[
                  currentType.key === "NO_SCHEDULE"
                    ? props.enums.ScheduleType.props[pastSchedule].key
                    : currentType.key
                ].component,
                {
                  planSettings: props.planSettings,
                  setPlanSettings: props.setPlanSettings
                }
              )}
            </div>
          </div>
          <NextSchedule
            scheduleInfo={props.planSettings.scheduleInfo}
            enums={props.enums}
            clients={props.clients}
            clientDetails={props.clientDetails}
            isBackupPlan={true}
          />
        </div>
        <BackupPlanAdvanced
          planSettings={props.planSettings}
          setPlanSettings={props.setPlanSettings}
        />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums,
    clients: state.dashboard.clients.list,
    clientDetails: state.backupSettings.clientDetails
  };
}

export default connect(mapStateToProps)(BackupPlanSchedule);
